import React, {useState, useEffect } from 'react'
import styled from "styled-components"
import media from "styled-media-query"

import { db } from "../../config/firebase"
import NewsModal from "../../components/NewsModal"

const News = () => {

   const [news, setNews] = useState([])

   useEffect(() => {
      db.collection("news").orderBy("date", "desc").get()
         .then((querySnapshot) => {
            const list = querySnapshot.docs.map(doc => doc.data())
            setNews(list)
         })
         .catch(err => console.log(err))
   }, [])

   const newsList = news.map((list, i) => {
      return (
         <NewsModal
            title={list.title}
            date={list.date}
            content={list.content}
            key={i}
         >
         </NewsModal>
      )
   })

   return (
      <NewsStyles>
         <div className="title-box">
            <h2>天心塾からのお知らせ</h2>
            <div className="deco"></div>
         </div>
         <div className="news">
            {newsList}
         </div>
      </NewsStyles>
   )
}

const NewsStyles = styled.section`
   width: 100%;
   background-color: #fff;
   .news {
      width: 100%;
      padding: 30px 0;
      .news-list {
         width: 90%;
         margin: 0 auto;
         height: 40px;
         display: flex;
         border-bottom: 1px solid #FF8787;
         color: #6E6E6E;
            color: #FF3D01;
         ${media.lessThan("600px")`
            width: 95%;
         `}
         &:hover {
            color: #FF8787;
            cursor: pointer;
         }
         &:first-child {
            border-top: 1px solid #FF8787;
         }
         &:nth-child(n + 10) {
            display: none;
         }
         p, h4 {
            line-height: 40px;
            text-align: center;
         }
         p {
            font-size: 1.8rem;
            width: 30%;
            ${media.lessThan("600px")`
               width: 40%;
               font-size: 1rem;
            `}
         }
         h4 {
            font-size: 2rem;
            width: 70%;
            ${media.lessThan("600px")`
               width: 60%;
               font-size: 1.8rem;
            `}
         }
      }
   }
`

export default News